import { render, staticRenderFns } from "./GiftCouponList.vue?vue&type=template&id=2e7bd1f5&scoped=true"
import script from "./GiftCouponList.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiftCouponList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GiftCouponList.vue?vue&type=style&index=0&id=2e7bd1f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bd1f5",
  null
  
)

export default component.exports